import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Anliegen, Subanliegen} from "../../../core/model/anliegen";
import {Dienststelle} from "../../../core/model/dienststelle";
import {NachrichtPayload} from "../../../core/model/nachricht/nachricht";

@Component({
  selector: 'kokos-nachricht-prepare-zav',
  imports: [],
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class NachrichtPrepareZavComponent implements OnInit {

  @Input() anliegenList: Anliegen[] = [];

  @Input() dienststelle: Dienststelle | null = null;

  @Output() nachrichtPayload = new EventEmitter<NachrichtPayload>();

  @Output() anliegenName = new EventEmitter<string>();

  @Output() subanliegenChanged = new EventEmitter<Subanliegen>();


  ngOnInit(): void {
    if (!this.anliegenList.length) {
      throw new Error('missing anliegen for zav');
    }
  }

}
